/**
 * Global namespace for components `sticky-top` class.
 */
const stickyTopClass = "sticky-top";
export default stickyTopClass;
